import { Statistics } from 'components/organisms';

const SpotifyStatisticsTab = () => {
  return <Statistics.SpotifyStatistics />;
};

export default SpotifyStatisticsTab;
